import Data from '../../../interface/dto/Data';
import { SalesChannel } from '../../../enum';
import { areIdsEqual } from '../../../helper/validator';
import { Id } from '../../../interface/AdditionalPageOptions';
import { StateProps } from '../interface';

/**
 * Finds a Tariff by a given hardwareId
 * @param tariffs Tariff[]
 * @param hardwareId Id
 * @returns Tariff | undefined
 */
export const findTariffById = (tariffs: Data[], hardwareId: Id) => {
    return tariffs && tariffs.find(({ hardware }) => areIdsEqual(hardware.hardwareId, hardwareId));
};

/**
 * Get Tariff object with subscription array filtered by salesChannel
 * @param state Stateprops
 * @returns Tariff
 */
export const getTariffBySales = (state: StateProps): Data | undefined => {
    const tariff = findTariffById(state.tariffs, state.selectedOption.hardwareId);

    if (!tariff) {
        return undefined;
    }

    const tariffs = tariff.tariffs?.filter(
        sub => sub.salesChannel === state.salesChannel
    ) || [];
    return {
        ...tariff,
        tariffs,
    };
};

/**
 * Find a subscription in given Tariff filtered by id and salesChannel
 *
 * @param tariff Tariff object to search in
 * @param id the id of the Subscription to look for
 * @param sales selected SalesChannel
 * @returns Subscription | undefined
 */
export const findSubscription = (tariff: Data, id: Id, sales: SalesChannel) => {
    return tariff?.tariffs.find(sub =>
        sub.salesChannel === sales
        && areIdsEqual(sub.virtualItemId, id));
};
